import { TarifvertragFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/TarifvertragFields/TarifvertragFields';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useStandort } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useStandort/useStandort';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { FieldGroup } from '@e2n/ui';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function FixgehaltFields() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { currentStandort } = useStandortContext();
  const eintrittsdatum =
    form.state.values.anstellungsverhaeltnis.anstellung.eintrittsdatum;
  const tarifvertragDatum = useMemo(
    () =>
      eintrittsdatum && dayjs(eintrittsdatum).isBefore(dayjs().startOf('day'))
        ? dayjs().startOf('day').toDate()
        : dayjs(eintrittsdatum).startOf('day').toDate(),
    [eintrittsdatum],
  );
  const { standort } = useStandort(currentStandort.id, tarifvertragDatum);

  if (
    standort?.tarifvertrag &&
    standort?.tarifvertrag.tarifgruppen.length > 0
  ) {
    return <TarifvertragFields standort={standort} showGehalt />;
  }

  return (
    <div className="flex flex-col pt-4 gap-6">
      <div className="flex flex-col gap-3">
        <h3 className="text-neutrals-900 text-base font-bold leading-6">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.verguetung.title',
          )}
        </h3>
        <span className="text-neutrals-800 text-sm font-normal leading-5">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.verguetung.description',
          )}
        </span>
      </div>
      <FieldGroup className="col-span-2 grid lg:grid-cols-2 items-start">
        <form.AppField name="bezahlung.bezahlungsart.stundenlohn">
          {(field) => (
            <field.MoneyInput
              label={t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.stundenlohn.label',
              )}
              isRequired
            />
          )}
        </form.AppField>
        <form.AppField name="bezahlung.bezahlungsart.monatsgehalt">
          {(field) => (
            <field.MoneyInput
              label={t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.monatsgehalt.label',
              )}
            />
          )}
        </form.AppField>
      </FieldGroup>
    </div>
  );
}
